import { z } from 'zod'

import { Category } from '@/types/shared/category'

/** Manager of the Konvives and clients. */
export const Manager = z.object({
    id: z.number().positive(),
    name: z.string().min(1),
    category: Category,
    email: z.string().email(),
    phone: z.string().min(1).max(13),
    // TODO: See later to add the .min(1) for optional values
    email_help: z.string().optional(),
    phone_help: z.string().max(13).optional(),
})

export type Manager = z.infer<typeof Manager>

export const ManagerBinding = Manager.pick({
    id: true,
    name: true,
})

export type ManagerBinding = z.infer<typeof ManagerBinding>
